(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brooklyn-age-gate"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('brooklyn-age-gate');
    if (!dialog) return;
    const key = 'brooklyn-smokes-age-acknowledgment-v1';
    let answer;
    try { answer = sessionStorage.getItem(key); } catch {}
    const save = value => { try { sessionStorage.setItem(key, value); } catch {} };
    const deny = () => {
      dialog.querySelector('[data-age-question]').hidden = true;
      dialog.querySelector('[data-age-denied]').hidden = false;
      dialog.setAttribute('aria-labelledby', 'bs-age-denied-heading');
      dialog.setAttribute('aria-describedby', 'bs-age-denied-description');
      dialog.querySelector('#bs-age-denied-heading').focus();
    };
    if (answer === 'accepted') {
      dialog.close();
      return;
    }
    dialog.removeAttribute('open');
    dialog.showModal();
    dialog.addEventListener('cancel', event => event.preventDefault());
    dialog.querySelector('[data-age-accept]').addEventListener('click', () => {
      save('accepted');
      document.documentElement.dataset.bsAgeAccepted = 'true';
      dialog.close();
      const main = document.getElementById('MainContent');
      if (main) {
        main.setAttribute('tabindex', '-1');
        main.focus({ preventScroll: true });
      }
    });
    dialog.querySelector('[data-age-decline]').addEventListener('click', () => {
      save('denied');
      deny();
    });
    if (answer === 'denied') deny();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["brooklyn-neon-logo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('brooklyn-neon-logo')) {
    customElements.define('brooklyn-neon-logo', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (this.dataset.initialized) return;
        const images = [...this.querySelectorAll('.bs-neon-logo__image')];
        const button = this.querySelector('.bs-neon-logo__pause');
        if (!button || images.length !== 4) return;
        this.dataset.initialized = 'true';
        button.addEventListener('click', () => {
          const paused = this.dataset.paused !== 'true';
          this.dataset.paused = String(paused);
          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        });
        Promise.all(images.map(image => image.decode().catch(() => null))).then(() => {
          if (images.every(image => image.naturalWidth > 0)) {
            this.dataset.ready = 'true';
            button.hidden = false;
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
